module.exports = __webpack_public_path__ + "img/nexultra-sunscreen-icon.a6ea81bc.svg";